import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Searchbox } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
export const DEBOUNCE_MS = 300;
export const GetActivityLogSearchTID = (parentTestId)=>getTestIds(parentTestId);
export const ActivityLogSearch = (param)=>{
    let { onChange, value, testId } = param;
    const { ActivityLogSearchTestIds } = useMemo(()=>GetActivityLogSearchTID(testId), [
        testId
    ]);
    const { t } = useLocaleKeys();
    return /*#__PURE__*/ _jsx(Searchbox, {
        bi: {
            name: 'activity_log_search'
        },
        testId: ActivityLogSearchTestIds.Input(),
        placeholder: t.activityLog.search.placeholder(),
        value: value,
        debounceTime: DEBOUNCE_MS,
        onChange: (e)=>onChange(e.target.value),
        onClear: ()=>onChange('')
    });
};
